
export const MAX_NUMBER_OF_FILES = process.env.MAX_NUMBER_OF_FILES ?? 100;
